module.exports = __webpack_public_path__ + "media/src/images/giftee-asterisk-54e46f2031481b9897a107ce8d18ce44.svg";